<main class="container-fluid px-0 pb-3 pb-lg-5">

  <div class="px-3 py-2 py-md-0 bg-darkest">
    <div class="container-lg">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="h3 fw-bold mb-0">{{ 'CATEGORIES.FAVOURITES' | translate}}</h1>
        <div class="category-icon-overlay">
          <img [src]="'assets/icons/favourites_big.svg'" alt="category background image" width="100%">
        </div>
      </div>
    </div>
  </div>

  <div class="container-lg">
    <div class="px-0 mt-0 mt-md-4">
      <!--      games -->
      <div *ngIf="favouriteGames && favouriteGames.length; else noGameBlock " class="pt-3">
        <div class="row row-cols-3 row-cols-md-4 row-cols-lg-6 g-2 g-sm-3 g-md-4">
          <div class="col" *ngFor="let g of favouriteGames">
            <app-game-item [game]="g" [favouriteIds]="favouriteIds" (gameLaunchEvent)="launchGame($event)"></app-game-item>
          </div>
        </div>
      </div>

      <ng-template #noGameBlock>
        <div class="container text-center pt-5 px-0 px-md-5">
            <h3>{{'HOME.NO_FAVOURITE_MESSAGE' | translate}}</h3>
            <h4 class="fs-4 d-flex flex-row flex-wrap justify-content-center align-items-center">
              <span>{{'HOME.NO_FAVOURITE_TIP' | translate}}</span>
              <span class="mx-2"><app-svg-icon [pathIdentifier]="'favourites'" class="variable-svg-icon d-block"></app-svg-icon></span>
              <span>{{'HOME.NO_FAVOURITE_TIP2' | translate}}</span>
            </h4>
            <p class="fs-5">{{'HOME.NO_RECENT_TIP2' | translate}}</p>
        </div>
      </ng-template>
    </div>
  </div>


  <div class="mt-4">
<!--    <app-carousel [dataList]="providers" [identifier]="'providerList'"></app-carousel>-->
    <app-providers-carousel></app-providers-carousel>
    <app-recommended-games></app-recommended-games>
    <app-carousel [dataList]="randomGamesForCarousel" [identifier]="'all'"></app-carousel>
  </div>



</main>
